/* ==========================================================================
   prinsert-search-toggle.js
   --------------------------------------------------------------------------
   Haelt den Platzhaltertext des Suchfelds immer lesbar:

     1. Viel Platz    voller Text in voller Schriftgroesse
     2. Weniger       voller Text, Schrift stufenweise kleiner
     3. Zu wenig      Schrift auf Untergrenze, Text wird zur Kurzfassung

   ==========================================================================
   DIE TEXTE KOMMEN AUS DEM MARKUP, NICHT AUS DIESER DATEI (24.08.2026)

   Frueher standen "Spiel oder Upgrade suchen" und "Suchen" hier fest im
   Code. Fuer Translate & Adapt sind Texte in JavaScript unsichtbar -- sie
   blieben auch in der englischen Fassung deutsch.

   snippets/header-search.liquid reicht sie jetzt als data-Attribute am
   Eingabefeld herein:

     data-text-lang   prinsert.suche.platzhalter_lang
     data-text-kurz   general.search.search

   DIE RUECKFALLWERTE UNTEN SIND ABSICHT, aber nur ein Notnagel: Fehlt ein
   Attribut, bleibt das Feld benutzbar statt leer -- der Text ist dann
   allerdings unuebersetzt. Wer hier deutschen Text sieht, wo englischer
   stehen sollte, sucht die Ursache im Snippet, nicht in dieser Datei.

   ==========================================================================
   ES WIRD GEMESSEN, NICHT GERATEN

   Eine feste Pixelgrenze je Schriftgroesse waere Ratearbeit: Wie breit ein
   Text tatsaechlich wird, haengt an der Schriftart (hier Montserrat), am
   Zeichenabstand und an der Zoomstufe des Browsers.

   Deshalb misst dieses Skript die echte Textbreite ueber ein verstecktes
   Element mit denselben Schrifteigenschaften wie das Eingabefeld -- und
   probiert die Groessen von oben nach unten durch, bis eine passt.

   DAS WIRD MIT DER UEBERSETZUNG WICHTIGER, NICHT UNWICHTIGER: Englische
   Texte sind meist kuerzer als deutsche, franzoesische deutlich laenger.
   Weil gemessen und nicht geschaetzt wird, passt sich das von selbst an --
   an den Groessen unten muss beim Hinzufuegen einer Sprache nichts
   geaendert werden.

   Gemessen wird gegen die INNENBREITE des Feldes, also abzueglich der
   Innenabstaende fuer Lupe und Loeschkreuz. Dazu kommt eine kleine
   Sicherheitsreserve, damit der Text nicht auf den letzten Pixel gequetscht
   wirkt.
   ========================================================================== */

(function () {
  if (window.__prinsertSearchToggleInit) return;
  window.__prinsertSearchToggleInit = true;

  /* Nur Notnagel -- siehe Kopf der Datei. */
  var FALLBACK_LANG = 'Spiel oder Upgrade suchen';
  var FALLBACK_KURZ = 'Suchen';

  /* Von gross nach klein durchprobiert. Unter 1.15rem wird es auf dem
     Bildschirm unangenehm zu lesen -- dort ist Schluss, und der Text
     wechselt stattdessen auf die Kurzfassung. */
  var GROESSEN = [1.6, 1.5, 1.4, 1.3, 1.2, 1.15];

  /* Reserve, damit der Text nicht exakt an der Kante endet. */
  var LUFT = 6;

  var messer = null;

  function holeMesser() {
    if (messer) return messer;

    messer = document.createElement('span');
    messer.setAttribute('aria-hidden', 'true');
    messer.style.position = 'absolute';
    messer.style.visibility = 'hidden';
    messer.style.whiteSpace = 'nowrap';
    messer.style.pointerEvents = 'none';
    messer.style.left = '-9999px';
    messer.style.top = '0';
    document.body.appendChild(messer);
    return messer;
  }

  function textBreite(input, text, groesseRem) {
    var el = holeMesser();
    var stil = window.getComputedStyle(input);

    el.style.fontFamily = stil.fontFamily;
    el.style.fontWeight = stil.fontWeight;
    el.style.fontStyle = stil.fontStyle;
    el.style.letterSpacing = stil.letterSpacing;
    el.style.fontSize = groesseRem + 'rem';
    el.textContent = text;

    return el.offsetWidth;
  }

  function innenBreite(input) {
    var stil = window.getComputedStyle(input);
    var links = parseFloat(stil.paddingLeft) || 0;
    var rechts = parseFloat(stil.paddingRight) || 0;
    return input.clientWidth - links - rechts - LUFT;
  }

  function setup(wrapper) {
    if (wrapper.__prinsertSearchToggle) return;
    wrapper.__prinsertSearchToggle = true;

    var input = wrapper.querySelector('.search__input');
    if (!input) return;

    /* Einmal beim Einrichten auslesen. Die Texte aendern sich waehrend
       eines Seitenaufrufs nicht -- ein Sprachwechsel laedt die Seite neu. */
    var textLang = input.getAttribute('data-text-lang') || FALLBACK_LANG;
    var textKurz = input.getAttribute('data-text-kurz') || FALLBACK_KURZ;

    /* Ist die Kurzfassung nicht kuerzer als die lange, bringt der Wechsel
       nichts. Kann bei manchen Sprachen vorkommen. */
    var kurzLohntSich = textKurz.length < textLang.length;

    function anpassen() {
      var platz = innenBreite(input);
      if (platz <= 0) return;

      /* Groesste Schrift suchen, in der der VOLLE Text noch passt. */
      for (var i = 0; i < GROESSEN.length; i++) {
        if (textBreite(input, textLang, GROESSEN[i]) <= platz) {
          input.style.fontSize = GROESSEN[i] + 'rem';
          input.placeholder = textLang;
          return;
        }
      }

      if (!kurzLohntSich) {
        input.style.fontSize = GROESSEN[GROESSEN.length - 1] + 'rem';
        input.placeholder = textLang;
        return;
      }

      /* Selbst in der kleinsten Groesse passt der volle Text nicht mehr.
         Dann die Kurzfassung -- die darf wieder groesser sein, weil sie
         deutlich weniger Platz braucht. */
      for (var j = 0; j < GROESSEN.length; j++) {
        if (textBreite(input, textKurz, GROESSEN[j]) <= platz) {
          input.style.fontSize = GROESSEN[j] + 'rem';
          input.placeholder = textKurz;
          return;
        }
      }

      input.style.fontSize = GROESSEN[GROESSEN.length - 1] + 'rem';
      input.placeholder = textKurz;
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(anpassen).observe(input);
    }

    window.addEventListener('resize', anpassen);

    /* Schriften laden asynchron nach. Vor dem Laden misst der Browser mit
       einer Ersatzschrift und kommt auf andere Breiten -- deshalb nach dem
       Laden noch einmal nachrechnen. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(anpassen);
    }

    anpassen();
  }

  function init() {
    document.querySelectorAll('.header__search--inline').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
